module.exports = __webpack_public_path__ + "img/ManufacturingChecked.bbca9fde.svg";